import React, { useContext, useState } from 'react'
import { useNavigate } from "react-router-dom"
import {
    AppBar,
    Box,
    CssBaseline,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Toolbar,
    Button,
    Avatar,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import { AppContext } from '././../../context/context/context.js'

const drawerWidth = 240

const DrawerAppBar = (props) => {
    const { window } = props
    const [mobileOpen, setMobileOpen] = useState(false)
    const { state } = useContext(AppContext)
    const navigate = useNavigate()

    const logo = 'https://firebasestorage.googleapis.com/v0/b/elaraby-photographer.appspot.com/o/logo.webp?alt=media&token=4e694c46-c462-43ea-83df-f57193d05f33'

    const handleDrawerToggle = () => setMobileOpen((prevState) => !prevState)

    const container = window !== undefined ? () => window().document.body : undefined

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', }}>
            <Box sx={{ p: 2, textAlign: '-webkit-center' }}>
                <Avatar
                    src={logo}
                    alt='Mohammed'
                    onClick={() => navigate('/')}
                    sx={{ cursor: 'pointer' }}
                />
            </Box>
            <Divider sx={{ bgcolor: state.color.primary, }} />
            <List>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/')}
                        sx={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 700,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                backgroundColor: '#368F80',
                            },
                        }}
                    >
                        <ListItemText primary={"Work"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate(`/about`)}
                        sx={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 700,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                backgroundColor: '#368F80',
                            },
                        }}
                    >
                        <ListItemText primary={"About"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate(`/offers`)}
                        sx={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 700,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                backgroundColor: '#368F80',
                            },
                        }}
                    >
                        <ListItemText primary={"Offers"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate(`/reservation`)}
                        sx={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 700,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                backgroundColor: '#368F80',
                            },
                        }}
                    >
                        <ListItemText primary={"Reservation"} />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box >
    )

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                component="nav"
                sx={{
                    bgcolor: '#FAFAFAE9',
                    boxShadow: `0px 0px 5px 0px ${state.color.primary}`,
                    py: '0.75%',
                    mb: '10%'
                }}
            >
                <Toolbar sx={{ justifyContent: { sm: 'space-between' } }}>
                    <IconButton
                        color="#000000"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ p: 2, textAlign: '-webkit-center' }}>
                        <Avatar
                            src={logo}
                            alt='Mohammed'
                            onClick={() => navigate('/')}
                            sx={{
                                cursor: 'pointer'
                            }}
                        />
                    </Box>
                    {/* <Box sx={{
                        width: { xs: "100%", sm: "0%" },
                        // display: { sm: "none" },
                        textAlign: '-webkit-center'
                    }}>
                        <Avatar
                            src={logo}
                            alt='logo'
                        />
                    </Box> */}
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Button
                            onClick={() => navigate('/')}
                            sx={{
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 700,
                                color: state.color.dark,
                                '&:hover': {
                                    color: state.color.light,
                                    backgroundColor: '#368F80',
                                },
                            }}
                        >
                            Work
                        </Button>
                        <Button
                            onClick={() => navigate(`/about`)}
                            sx={{
                                fontFamily: "Montserrat, sans-serif",
                                color: state.color.dark,
                                fontWeight: 700,
                                '&:hover': {
                                    color: state.color.light,
                                    backgroundColor: '#368F80',
                                },
                            }}
                        >
                            About
                        </Button>
                        <Button
                            onClick={() => navigate(`/offers`)}
                            sx={{
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 700,
                                color: state.color.dark,
                                '&:hover': {
                                    color: state.color.light,
                                    backgroundColor: '#368F80',
                                },
                            }}
                        >
                            Offers
                        </Button>
                        <Button
                            onClick={() => navigate(`/reservation`)}
                            sx={{
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 700,
                                color: state.color.dark,
                                '&:hover': {
                                    color: state.color.light,
                                    backgroundColor: '#368F80',
                                },
                            }}
                        >
                            Reservation
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            color: state.color.dark,
                            bgcolor: state.color.light,
                            boxShadow: `0px 0px 15px 1px ${state.color.primary}`,
                        },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
        </Box >
    )
}

export default DrawerAppBar
